import Request from '@/services/request';
import {
  SATURDAY_SHIPMENT_POPUP,
  SATURDAY_SHIPMENT_SAVE,
} from '@/utils/enum/endpoints';
import {
  GET_POPUP_PENDING,
  GET_POPUP_SUCCESS,
  GET_POPUP_FAIL,
  SAVE_SELECTION_PENDING,
  SAVE_SELECTION_SUCCESS,
  SAVE_SELECTION_FAIL,
} from './mutation-types';

const request = new Request();

const BASE_CONFIG = {
  baseURL: '/sellerofficeapi/rest',
  headers: { Accept: 'application/json' },
};

export default {
  async getPopupData({ commit }) {
    commit(GET_POPUP_PENDING);
    try {
      const { data } = await request.get(
        SATURDAY_SHIPMENT_POPUP,
        null,
        BASE_CONFIG,
      );
      commit(GET_POPUP_SUCCESS, data);
      return data;
    } catch (error) {
      commit(GET_POPUP_FAIL, error);
      return Promise.reject(error);
    }
  },

  async saveSelection({ commit }, value) {
    commit(SAVE_SELECTION_PENDING);
    try {
      const { data } = await request.post(
        SATURDAY_SHIPMENT_SAVE,
        { value },
        BASE_CONFIG,
      );
      commit(SAVE_SELECTION_SUCCESS);
      return data;
    } catch (error) {
      commit(SAVE_SELECTION_FAIL, error);
      return Promise.reject(error);
    }
  },
};
